import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import BASEURL from '../API/Config';

const SalesList = () => {
  const [salesOrders, setSalesOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);

  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchSalesOrders = async () => {
      try {
        const response = await fetch(`${BASEURL}/sales-order/list`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error('Failed to fetch sales orders');

        const data = await response.json();
        setSalesOrders(data);
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to load sales orders.',
        });
      }
    };

    fetchSalesOrders();
  }, [token]);

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
  };

  const handleCloseDetails = () => {
    setSelectedOrder(null);
  };

  return (
    <div className="container mt-5">
      <br />
      {selectedOrder ? (
        <div
          className="p-4 shadow-sm rounded"
          style={{ backgroundColor: '#f8f9fa' }}
        >
          <h4>Sales Order Details</h4>
          <p>
            <strong>Customer:</strong> {selectedOrder.customerName}
          </p>
          <p>
            <strong>Order Date:</strong> {selectedOrder.orderDate}
          </p>
          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Item Name</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {selectedOrder.items.map((item, index) => (
                <tr key={index}>
                  <td>{item.itemName}</td>
                  <td>{item.quantity}</td>
                  <td>{item.price.toFixed(2)}</td>
                  <td>{(item.quantity * item.price).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="text-end">
            <strong>Total Amount:</strong>{' '}
            {selectedOrder.totalAmount.toFixed(2)}
          </p>
          <button className="btn btn-secondary" onClick={handleCloseDetails}>
            Back to List
          </button>
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Customer</th>
                <th>Order Date</th>
                <th>Total Amount</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {salesOrders.map((order, index) => (
                <tr key={order._id}>
                  <td>{index + 1}</td>
                  <td>{order.customerName}</td>
                  <td>{order.orderDate}</td>
                  <td>{order.totalAmount.toFixed(2)}</td>
                  <td>
                    <button
                      className="btn btn-info btn-sm"
                      onClick={() => handleViewDetails(order)}
                    >
                      View Details
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SalesList;
